import { Link, useLocation } from "react-router-dom";
import { useDraft } from "../../../shared/context/DraftContext.js";
import { useCourseSlug } from "../../../shared/lib/coursePath.js";
import { problemTarget } from "../lib/problemTarget.js";
import type { Problem } from "../lib/validation.js";
import styles from "../../../shared/components/shell.module.css";
import own from "./problemList.module.css";

/**
 * Hinweise – jeder mit dem Weg zu seiner Stelle.
 *
 * Vorher stand vor jedem Hinweis sein Pfad als Text: `lessons.grundreihe-4a.
 * grundreihe-4a.stufe-1.text`. Das ist die Auskunft, die ein Entwickler braucht,
 * und für die Redaktion Zeichensalat.
 *
 * Der Link steht dort, wo er woandershin führt – und nur dort. Das ist genau der
 * wichtige Fall: „Zeichen q hat keine Finger-Zuordnung“ erscheint an der Stufe,
 * behoben wird es in den Grundlagen. Ein Verweis auf die Seite, auf der man
 * schon steht, wäre dagegen nur Rauschen.
 *
 * `compact` betrifft allein die Darstellung am Feld, nicht den Link.
 */
export function ProblemList({
  problems,
  withoutPath,
}: {
  problems: readonly Problem[];
  withoutPath?: boolean;
}) {
  const { bundle, publishedBundle } = useDraft();
  const slug = useCourseSlug();
  const here = useLocation().pathname;
  if (problems.length === 0) return null;

  return (
    <div
      className={`${styles.notice} ${styles.noticeError} ${withoutPath ? own.small : ""}`}
    >
      <ul className={own.list}>
        {problems.map((p, i) => {
          const target = problemTarget(p, bundle, slug, publishedBundle);
          const elsewhere = target.to.split("#")[0] !== here;
          return (
            <li key={`${p.path}-${i}`}>
              {p.message}
              {elsewhere && (
                <>
                  {" "}
                  <Link className={own.to} to={target.to}>
                    → {target.label}
                  </Link>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
